class PdpAddToCart extends HTMLElement {
  constructor() {
    super();
    if (!this.classList.contains("pdp-add-to-cart--enabled") || this.dataset.hasSub !== 'true') {
      return;
    }
    this.wrap = this.closest(".pdp-add-to-cart__wrap")
    this.selectButton = this.querySelector(".sub-select__button");
    this.selectDropdown = this.querySelector(".sub-select__dropdown");
    this.subInput = this.querySelector("[data-option='sub']");
    this.otpInput = this.querySelector("[data-option='otp']");
    this.optionsArr = this.selectDropdown.querySelectorAll(
      ".radio-swatches--basic"
    );
    this.selectButton.addEventListener("click", () =>
      this.dropdownVisibilityHandler("toggle")
    );
    this.addEventListener("blur", () =>
      this.dropdownVisibilityHandler("hide")
    );
    this.optionsArr.forEach((option) => {
      option.addEventListener("click", (e) => this.optionHandler(e));
    });
    window.addEventListener("load", () => {
      this.headerHeight = document.querySelector(".header-wrapper").offsetHeight;
      this.wrap.style.top = `${this.headerHeight}px`;
      if ("IntersectionObserver" in window) {
        this.startObserving();
      }
    });
  }
  connectedCallback() {
    if (!this.classList.contains("pdp-add-to-cart--enabled") || this.dataset.hasSub !== 'true') {
      return;
    }
    this.root = this.closest(".product-details");
    this.input = this.root.querySelector("[data-subscription-option]");
    this.otpOption = this.root.querySelector("input[id^='otp-option']");
    this.formSubmit = this.root.querySelector("product-form");
    this.statusHandler();
    this.input.addEventListener("change", () => this.statusHandler());
  }
  statusHandler() {
    const input = this.otpOption.checked ? this.otpInput : this.subInput;
    input.setAttribute("checked", "true");
    this.setActiveHandler(input);
  }
  dropdownVisibilityHandler(state) {
    if (state === "toggle") {
      this.classList.toggle("active");
    } else {
      this.classList.remove("active");
    }
  }
  optionHandler(e) {
    this.setActiveHandler(e.currentTarget);
    this.dropdownVisibilityHandler("hide");
  }
  setActiveHandler(input) {
    this.selectButton.dataset.selected = input.dataset.option;
  }
  startObserving() {
    let options = {
      root: null,
      rootMargin: `-${this.headerHeight}px 0px 0px 0px`,
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting || entries[0].boundingClientRect.top > this.headerHeight) {
        this.wrap.classList.remove("active");
      } else {
        this.wrap.classList.add("active");
      }
    }, options);
    observer.observe(this.formSubmit);
  }
}
customElements.define("pdp-add-to-cart", PdpAddToCart);